import { render, staticRenderFns } from "./AllOrders.vue?vue&type=template&id=6e8ab2e0&scoped=true"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ab2e0",
  null
  
)

export default component.exports